<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" v-if="false">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单维护</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="20" v-if="query_flag === 1">
          <el-input placeholder="请输入车牌查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px " @clear="getorderList" @change="getorderList">
            <el-button slot="append" icon="el-icon-search" @click="getorderList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
        </el-col>

      </el-row>
      <el-row :gutter="0" class="el_row_two" id="report">
        <el-col :span="24">
          <el-table :data="orderList" style="width: 100%" border stripe highlight-current-row
            @selection-change="handleSelectionChange" ref="orderListRef">
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column type="expand">
              <template slot-scope="scope">
                <!-- <pre> {{scope.row}}</pre> -->
                <el-table :data="scope.row.yy_list" stripe>
                  <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
                  <el-table-column prop="yy_bianhao" label="编号"></el-table-column>
                  <el-table-column prop="paizhao" label="牌照"></el-table-column>
                  <el-table-column prop="pro_count" label="数量"></el-table-column>
                  <el-table-column prop="yy_money" label="项目总价"></el-table-column>
                  <el-table-column label="车型" width="350">
                    <template v-slot="scope002"> <span>{{ scope002.row.chexing01 }}: {{ scope002.row.chexing02 }}:{{
      scope002.row.chexing03
    }}:{{ scope.row.chexing04 }}</span></template>
                  </el-table-column>
                  <el-table-column prop="pro_name" label="项目"></el-table-column>

                  <el-table-column prop="yy_on_time" label="开始时间"></el-table-column>
                  <el-table-column prop="yy_off_time" label="结束时间"></el-table-column>

                  <el-table-column prop="mac_bianhao" label="客户信息">
                    <template v-slot="scope002"> <span>{{ scope002.row.guest_bianhao }}: {{ scope002.row.guest_name }}:
                        {{ scope002.row.guest_mob }}</span></template>
                  </el-table-column>
                  <el-table-column prop="mac_bianhao" label="指派员工信息">
                    <template v-slot="scope002"> <span>{{ scope002.row.yuangong_bianhao }}: {{
      scope002.row.yuangong_name
    }}:
                        {{ scope.row.yuangong_mob }}</span></template>
                  </el-table-column>
                  <el-table-column prop="mac_bianhao" label="当前状态">
                    <template v-slot="scope002"> <span> {{ scope002.row.status_flag === 1 ? '未开始' : '' }}{{
      scope002.row.status_flag === 2 ?
        '正在进行' : '' }}{{ scope002.row.status_flag === 3 ? '服务结束' : '' }}</span></template>
                  </el-table-column>
                  <el-table-column prop="mac_bianhao" label="质检状态">
                    <template v-slot="scope002"> <span> {{ scope002.row.zhijian_status === 1 ? '不合格' : '' }}{{
      scope002.row.zhijian_status === 2 ?
        '需整改' : '' }}{{ scope002.row.zhijian_status === 3 ? '合格' : '' }}</span></template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>

            <el-table-column prop="uid" label=" 序号" width="80" type="selection"
              v-if="select_flag === 1"></el-table-column>
            <el-table-column prop="order_bianhao" label="编号" width="150"></el-table-column>
            <el-table-column prop="guest_name" label="姓名"  ></el-table-column>
            <el-table-column prop="paizhao" label="牌照"  ></el-table-column>
            <el-table-column prop="order_money" label="金额"></el-table-column>
         
            <el-table-column prop="guest_mob" label="客户手机"></el-table-column>
            <el-table-column label="车型" width="400" v-if="shangcheng_flag === 0">
              <template v-slot="scope"> {{ scope.row.chexing01 }} : {{ scope.row.chexing02 }} : {{ scope.row.chexing03
                }}
                : {{ scope.row.chexing04 }}</template>
            </el-table-column>
            <el-table-column prop="add_time" label="订单时间"></el-table-column>
            <el-table-column prop="yuangong_bianhao" label="操作员工"></el-table-column>
              <el-table-column prop="yuangong_name" label="员工姓名"></el-table-column>
            <el-table-column prop="pay_flag" label="支付状态"  >
              
              <template v-slot="scope"> <span> {{ scope.row.pay_flag === 1 ? '已支付' : '未支付' }}</span></template>
            </el-table-column>
            <el-table-column prop="order_memo" label="订单备注"></el-table-column>
            <el-table-column prop="cheliang_gonglishu" label="车辆里程"></el-table-column>
            <el-table-column label="操作" v-if="caozuo_type === 1">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="结算订单" placement="top" :enterable="false"
                  v-if="shangcheng_flag === 0 && order_type === 0" >
                  <el-button type="primary" icon="el-icon-paperclip" @click="get_jiesuan_add(scope.row)" circle
                    size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="生成报价单" placement="top" :enterable="false"
                  v-if="shangcheng_flag === 0">
                  <el-button type="primary" icon="el-icon-s-order" @click="order_show(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false" v-if="order_type===0">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini"
                    @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="订单回访" placement="top" :enterable="false"
                  style="display: none;" v-if="false">
                  <el-button type="success" icon="el-icon-orange" @click="showHuifangDialog(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>

      <el-dialog title="订单详情" :visible.sync="infoDialogVisible" width="90%">
        <func ref="kaidanFuncRef" :orderInfo="orderInfo" show_type="cheliang_info" :diaoyongType="1"
          :key="datekey">
        </func>
      </el-dialog>
      <el-dialog title="订单结算" :visible.sync="jiesuanDialogVisible" width="90%">
        <jiesuanAdd ref="jiesuanAddFuncRef" :key="datekey" :jiesuanSingleOrderInfo="jiesuanSingleOrderInfo" singleFlag="1"
          @jiesuan_addClose="jiesuan_addClose"> </jiesuanAdd>
      </el-dialog>

      <!-- 订单回访窗口 -->
    </el-card>
    <span style="color: #666;font-size:small;" v-if="caozuo_type === 0"> 温馨提示：下一步按钮将 一键确认所有选中订单的服务订单</span>
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from '../config/validator';
import jiesuanAdd from './jiesuan_add.vue'
import exportExcel from '../config/exportExcel'
import func from './func.vue'
export default {
  props: ['paizhao', 'caozuo_type', 'query_flag', 'add_flag', 'order_type', 'shangcheng_flag', 'select_flag'],
  // caozuo_type 是否显示后边的操作按钮 0 不显示 1 显示，
  // query_flag 是否显示查询输入框 1 显示 0 不显示
  // paizhao 牌照作为查询条件
  // add_flag 
  // order_type 0未支付订单  1 已支付订单    
  // shangcheng_flag 是否是商城订单页面调用
  // select_flag 是否可以选择参数
  components: {
    func: func,
    jiesuanAdd: jiesuanAdd
  },
  data() {
    return {
      jiesuanSingleOrderInfo: {},
      array_order: [],
      orderInfo: {},
      infoDialogVisible: false,
      datekey: Date.now(),
      orderLy_options: [
        {
          value: 1,
          label: '订单介绍'
        },
        {
          value: 2,
          label: '回访订单'
        },
        {
          value: 3,
          label: '上门订单'
        }
      ],
      order_options: [
        {
          value: 1,
          label: '初级订单'
        },
        {
          value: 2,
          label: '中级订单'
        },
        {
          value: 3,
          label: '高级订单'
        }
      ],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list_more',
        C_table_name: 'order_list_more',
        query: this.paizhao,
        pageNum: 1,
        pageSize: 10,
        CI_canshu01: this.mendianUid, // 门店uid
        CI_canshu02: this.order_type// 0未支付订单  1 已支付订单   
      },
      huifang_isDisable: false,
      add_isDisable: false,
      orderList: [],
      //  recordCount: 0,
      total: 0,
      editDialogVisible: false,
      huifangDialogVisible: false,
      // 用于设置回访页面滑块值
      //  添加表单数据项
      huifangForm: {
        C_type: 'huifang_add',
        huifang_order_uid: 0,
        huifang_title: '',
        hufiang_memo: '',
        huifang_genjin: 1,
        huifang_yuangong_uid: 0,
        huifang_switch: true
      },
      addForm: {
        C_type: 'order_add',
        order_bianhao: '',
        order_name: '',
        order_mob: '11111111111',
        order_addr: '',
        order_sfz_bianhao: '111111111111111111',
        order_level: 1,
        order_price_want: 0,
        order_yixiang: '',
        order_memo: '',
        order_laiyuan: 1
      },
      // 用于修改数据绑定
      editForm: {},
      jiesuanDialogVisible: false,
      // 表单规则项
      addFormRules: {
        order_name: [
          { required: true, message: '请输入订单名称', trigger: 'blur' },
          { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
        ],

        order_mob: [
          {
            validator: checkMobileTest.bind(
              this.addForm && this.addForm.order_mob
            )
          }
        ],
        order_sfz_bianhao: [
          {
            validator: checkSfzId.bind(
              this.addForm && this.addForm.order_sfz_bianhao
            )
          }
        ]
      },

      huifangFormRefRules: {
        huifang_title: [
          { required: true, message: '请输入回访标题', trigger: 'blur' },
          { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.queryInfo.query = this.paizhao
    this.getorderList();
  },
  methods: {
    handleExport() {
      exportExcel('report', '二维码列表.xlsx')
    },
    handleSelectionChange(val) {
      console.log(val)
      // 实现单选
      if (val.length > 1) {
        this.$refs.orderListRef.clearSelection()
        this.$refs.orderListRef.toggleRowSelection(val.pop())
      }

      this.array_order = val
      this.$emit('get_order_selected_uid', this.array_order)
      // 对所有的选中的结算订单进行结算

      // val.forEach(function (item) {
      //   console.log(item)
      //   this.uid_yy.push(item.uid)
      // })
    },

    async order_show(uid) {
      var queryInfoOrder = {
        C_type: 'get_info',
        C_table_name: 'order_info',
        uid: uid
      }
      const { data: res } = await this.$http.get('get_api', {
        params: queryInfoOrder
      })
      this.orderInfo = JSON.parse(res.data)[0].data[0]
      console.log('orderInfo', this.orderInfo)
      this.datekey = Date.now()
      this.infoDialogVisible = true
    },
    kaidan_addClose(data) {
      this.addDialogVisible = false
      this.getorderList();
    },
    get_switch_value(switchValue) {
      this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
      console.log(this.huifangForm.huifang_genjin);
    },
    async huiFangAdd() {
      const { data: res } = await this.$http.post('api', this.huifangForm);
      console.log(JSON.parse(res.data)[0].bianhao_s);
      this.huifangDialogVisible = true;
    },
    getorderList_flush() {
      this.getorderList.CI_canshu02 = 0 // 设置未支付状态，然后显示
      this.getorderList()
    },
    async getorderList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      console.log('list', JSON.parse(res.data))
      this.orderList = JSON.parse(res.data)[0].dataList;

      if (!this.orderList) return;
      this.orderList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    },
    // 结算订单操作
    async get_jiesuan_add(data) {
      this.datekey = Date.now()
      this.jiesuanDialogVisible = true 
      this.jiesuanSingleOrderInfo = data
    },
    jiesuan_addClose() {
      this.jiesuanDialogVisible = false
      this.getorderList();
    },

    // 删除一条记录
    async deleteForm(orderUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      // console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'order_del',
        C_data1: orderUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getorderList();
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getorderList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getorderList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}
</style>
